import axios from 'axios';
import { apiUrl } from './apiUrl';

export const dates = () => axios.get(`${apiUrl}/stats/advancedDates`);



// WEBPACK FOOTER //
// ./src/services/smartparking-api/Stats.js